import React from 'react'
import s from './Cards.module.css'
import cards from '../../assets/img/wallet.png'
import cards_mobile from '../../assets/img/mobile/wallet.png'
import CustomBtnPink from '../../components/ui/customBtnPink/CustomBtnPink'
import { OPEN_ACCOUNT } from '../../router/Constants'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import card_image1 from '../../assets/img/cadsBolockImg1.png'
import card_image2 from '../../assets/img/cardsBlockImg2.png'
import Hero from '../../components/hero/Hero'
import { useTranslation } from 'react-i18next'
import {Helmet} from "react-helmet-async";

const Cards = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className={s.wrapper}>

      <Helmet>
        <title>Cards | Wall Street IBU</title>
        <meta
            name="description"
            content="Modern cards built on secure, compliant infrastructure. Global transactions and innovative banking with Wall Street IBU."
        />
        <meta name="keywords" content="global digital bank, international banking card, digital assets banking, international banking card"/>
      </Helmet>

      <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}>
        <div className={s.content}>
          <Hero
            title_1={t('cards.hero.title')}
            description={t('cards.hero.description')}
          />

          <div className={s.card_block_desc}>
            <div className={s.card_block_desc_left}>
              <p className={s.card_block_desc_paragraph}>
                {t('cards.block1.paragraph1')}
              </p>
              <p className={s.card_block_desc_paragraph}>
                {t('cards.block1.paragraph2')}
              </p>
            </div>
            <div className={s.card_block_desc_right}>
              <img
                className={s.desc_image}
                src={card_image1}
                alt={t('cards.block1.imageAlt', 'card_block Description')}
              />
            </div>
          </div>

          <div className={s.cards_block}>
            <div className={s.flex} dir='ltr'>
              <div className={s.cards_description_block}>
                <div className={s.cards_description_content}>
                  {t('cards.block2.paragraph1')}
                </div>
                <div className={s.cards_description_content}>
                  {t('cards.block2.paragraph2')}
                </div>

                <div className={s.cards_button_block}>
                  <div className={s.cards_wrapper}>
                    <CustomBtnPink
                      title={t('cards.button.title')}
                      onClick={() => navigate(OPEN_ACCOUNT)}
                    />
                  </div>
                </div>
              </div>
              <div className={s.cards_img_block}>
                <img src={cards_mobile} className={s.cards_mobile} alt='' />
                <img src={cards} className={s.cards} alt='' />
              </div>
            </div>
          </div>

          <div className={s.card_block_desc}>
            <div className={s.card_block_desc_left}>
              <img
                className={s.desc_image}
                src={card_image2}
                alt={t('cards.block3.imageAlt', 'card_block Description')}
              />
            </div>
            <div className={s.card_block_desc_right}>
              <p className={s.card_block_desc_paragraph}>
                {t('cards.block3.paragraph1')}
              </p>
              <p className={s.card_block_desc_paragraph}>
                {t('cards.block3.paragraph2')}
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default Cards;
